<template>
  <div v-if="loaded">
    <nav class="mx-4 border-b border-gray-dark">
        <h2 class="font-bold text-xl px-4 py-4">Ambassador Program</h2>
    </nav>

    <ambassador-dashboard v-if="has_ambassador_code"></ambassador-dashboard>
    <ambassador-invitation v-else></ambassador-invitation>
</div>
<div v-else>
    <loading />
</div>
</template>

<script>
import AmbassadorInvitation from './AmbassadorInvitation.vue'

export default {
  components: { AmbassadorInvitation },
    data() {
        return {
            loaded: true,
            has_ambassador_code: window.User.ambassador_code !== null,
        }
    },
}
</script>

<style>

</style>